import clsx from 'clsx';
import { Icon } from '@spotted-zebra-uk/ui-components';
import { ProjectCandidateStageCategory } from 'generated/graphql';
import { STAGE_CATEGORY_ICONS } from '../../Projects.constants';
import styles from './StageTypeChip.module.scss';

export const STAGE_TYPE_CHIP_DATA_TEST_ID = 'stage-type-chip';

const CHIP_CLASS_NAMES: Record<ProjectCandidateStageCategory, string> = {
  [ProjectCandidateStageCategory.ShortlistStage]: styles.shortlistStage,
  [ProjectCandidateStageCategory.OnlineAssessment]: styles.onlineAssessment,
  [ProjectCandidateStageCategory.AiInterview]: styles.aiInterview,
  [ProjectCandidateStageCategory.InterviewStage]: styles.interviewStage,
  [ProjectCandidateStageCategory.ContentStage]: styles.contentStage,
  [ProjectCandidateStageCategory.OfferStage]: styles.offerStage,
  [ProjectCandidateStageCategory.NotInAStage]: styles.neutralStage,
};

/**
 * The round coloured icon standing for one kind of stage. Decorative: every
 * caller states the stage name in text alongside it.
 */
const StageTypeChip = ({
  category,
  isSmall = false,
}: {
  category: ProjectCandidateStageCategory;
  isSmall?: boolean;
}) => {
  const icon = STAGE_CATEGORY_ICONS[category];

  return (
    <span
      className={clsx(
        styles.chip,
        CHIP_CLASS_NAMES[category],
        isSmall && styles.chipSmall
      )}
      data-testid={`${STAGE_TYPE_CHIP_DATA_TEST_ID}-${category}`}
      aria-hidden
    >
      {icon && <Icon icon={icon} className={styles.icon} />}
    </span>
  );
};

export default StageTypeChip;
